import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface ICreateMatchListGroupPayload {
    data: {
        name: string
        matchLists: any
    }
}

export interface ICreateMatchListGroupState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateMatchListGroupState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createMatchListGroup = createSlice({
    name: 'matchListGroup/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateMatchListGroupPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createMatchListGroupActions = createMatchListGroup.actions
export default createMatchListGroup.reducer
